import { render, staticRenderFns } from "./addFolderDialog.vue?vue&type=template&id=91f9e0ea&scoped=true"
import script from "./addFolderDialog.vue?vue&type=script&lang=js"
export * from "./addFolderDialog.vue?vue&type=script&lang=js"
import style0 from "./addFolderDialog.vue?vue&type=style&index=0&id=91f9e0ea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f9e0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f9e0ea')) {
      api.createRecord('91f9e0ea', component.options)
    } else {
      api.reload('91f9e0ea', component.options)
    }
    module.hot.accept("./addFolderDialog.vue?vue&type=template&id=91f9e0ea&scoped=true", function () {
      api.rerender('91f9e0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/components/addFolderDialog.vue"
export default component.exports